/* eslint-disable quote-props */

export const deleteFormField = [
  {
    hint: 'Provide delete',
    key: 'delete',
    label: 'Type "delete" for deletion',
    placement: 'left',
    type: 'edit_text',
    'v_max': {
      err: 'Delete is too long (2 - 100)',
      value: 100
    },
    'v_min': {
      err: 'Delete is too short (2 - 100)',
      value: 2
    },
    'v_required': {
      err: 'Type delete',
      value: true
    },
    valid: true,
    value: ''
  }
]

export const filterFormField = {
  location: {
    key: 'location',
    label: 'Location / Zip code',
    type: 'textField',
    inputImage: require('../../assets/images/location.svg'),
    imageAlt: 'Location Icon Image',
    value: '',
    placeholder: 'Type location',
  },
  radius: {
    key: 'radius',
    label: 'Radius (miles)',
    type: 'slider',
    marks: [
      {
        value: 1,
        label: '1'
      },
      {
        value: 100,
        label: '100'
      },
    ]
  },
  storeType: {
    key: 'storeType',
    label: 'Screen Type',
    type: 'select',
    inputImage: require('../../assets/images/shop.svg'),
    imageAlt: 'Store Icon Image',
    value: '',
    placeholder: 'Choose type',
    items: [
      {
        key: 'store1',
        value: 'Store 1'
      },
      {
        key: 'store2',
        value: 'Store 2'
      },
      {
        key: 'store3',
        value: 'Store 3'
      },
    ]
  },
  audience: {
    key: 'audience',
    label: 'Audience ethnicity',
    type: 'select',
    inputImage: require('../../assets/images/user.svg'),
    imageAlt: 'User Icon Image',
    value: '',
    placeholder: 'Choose audience',
    items: [
      {
        key: 'user1',
        value: 'User 1'
      },
      {
        key: 'user2',
        value: 'User 2'
      },
      {
        key: 'user3',
        value: 'User 3'
      },
    ]
  },
  startDate: {
    key: 'startDate',
    label: 'Start Date',
    type: 'dateField',
    position: 'left',
    inputImage: require('../../assets/images/calendar.svg'),
    imageAlt: 'calender Icon Image',
    value: '',
    placeholder: 'DD/MM/YY',
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    type: 'dateField',
    position: 'Right',
    inputImage: require('../../assets/images/calendar.svg'),
    imageAlt: 'calender Icon Image',
    value: '',
    placeholder: 'DD/MM/YY',
  },
  exclusions: {
    key: 'exclusions',
    label: 'Exclusions',
    type: 'select',
    inputImage: require('../../assets/images/filter-remove.svg'),
    imageAlt: 'Filter Remove Icon Image',
    value: '',
    placeholder: 'Exclude filter',
    items: [
      {
        key: 'exclusions1',
        value: 'exclusions 1'
      },
      {
        key: 'exclusions2',
        value: 'exclusions 2'
      },
      {
        key: 'exclusions3',
        value: 'exclusions 3'
      },
    ]
  }
}


// WEBPACK FOOTER //
// ./src/common/data/data.js